import React, { useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import renderMediaIcon from '../../../utils/renderMediaIcon';
import styles from './socialMediaIcons.module.scss';

const SocialMediaIcons = () => {
    const [redesSociales, setRedesSociales] = useState<any>([]);
    useEffect(() => {
        const _get = fetch('/components/footer-info.json');
        _get.then(async (resp) => {
            const footerInfo = await resp.json();
            setRedesSociales(footerInfo[0].redesSociales);
        });
    }, []);

    const renderIcon = (red, index) => {
        if (red.icon.includes('icon-')) {
            return (
                <a href={red.link} aria-label={red.titulo} key={index}>
                    <i className={red.icon} />
                </a>
            );
        } else {
            return (
                <a href={red.link} aria-label={red.titulo} key={index}>
                    {renderMediaIcon(red.icon)}
                </a>
            );
        }
    };

    return (
        <div className={styles.m_social_media_icons}>
            <span className={styles.m_social_media_icons__title}>Síguenos</span>
            <Box className={styles.m_social_media_icons__rrss}>
                {redesSociales.map((red, index) => renderIcon(red, index))}
            </Box>
        </div>
    );
};

export default SocialMediaIcons;
